import axios from "axios";
import store from "@/store";
import axiosplugin from "./axios";
//import config from '../../config.dev'

const CancelToken = axios.CancelToken;
let source = CancelToken.source();
const options = {
	responseType: "text",
	timeout: 30000,
	cancelToken: source.token,
};
export default {
	cancelCall() {
		source.cancel("Operation canceled.");
		source = CancelToken.source();
	},
	getProjects(page = 1, itemsPerPage = 1, sortBy, sortOrder, search, status) {
		var params = {
			page: page,
			itemsPerPage: itemsPerPage,
			search: search,
			sortBy: sortBy === "projectName" ? "name" : sortBy,
			desc: sortOrder,
			status: status,
		};
		return new Promise(function(resolve, reject) {
			axiosplugin
				.get(
					config.VUE_APP_EXTRACTION + "/api/v1/projects",
					{ params },
					options
				)
				.then((response) => {
					resolve(response);
				})
				.catch((e) => {
					console.log("error: ", e);
					reject(e);
				});
		});
	},
	getProject(id) {
		return new Promise(function(resolve, reject) {
			axiosplugin
				.get(config.VUE_APP_EXTRACTION + "/api/v1/projects/" + id, {})
				.then((response) => {
					resolve(response);
				})
				.catch((e) => {
					console.log("error: ", e);
					reject(e);
				});
		});
	},
	getUserInfo() {
		return new Promise(function(resolve, reject) {
			axiosplugin
				.get(config.VUE_APP_EXTRACTION + "/api/v1/self", options)
				.then((response) => {
					resolve(response);
				})
				.catch((e) => {
					console.log("error: ", e);
					reject(e);
				});
		});
	},
	getRoles() {
		return new Promise(function(resolve, reject) {
			axiosplugin
				.get(config.VUE_APP_EXTRACTION + "/api/v1/users/getroles", options)
				.then((response) => {
					resolve(response);
				})
				.catch((e) => {
					console.log("error: ", e);
					reject(e);
				});
		});
	},
	getChangesBy(
		page = 1,
		itemsPerPage,
		user,
		sortBy,
		sortOrder,
		search = null,
		status = null
	) {
		return new Promise(function(resolve, reject) {
			var params = {
				page: page,
				itemsPerPage: itemsPerPage,
				search: search,
				sortBy: sortBy,
				desc: sortOrder,
				status: status,
			};
			axiosplugin
				.get(
					config.VUE_APP_EXTRACTION + "/api/v1/users/" + user + "/logs",
					{ params },
					options
				)
				.then((response) => {
					resolve(response);
				})
				.catch((e) => {
					console.log("error: ", e);
					reject(e);
				});
		});
	},
	getStatusLogs(
		page = 1,
		itemsPerPage,
		sortBy,
		sortOrder,
		search = null,
		status = null
	) {
		return new Promise(function(resolve, reject) {
			var params = {
				page: page,
				itemsPerPage: itemsPerPage,
				search: search,
				sortBy: sortBy,
				desc: sortOrder,
				status: status,
			};
			axiosplugin
				.get(
					config.VUE_APP_EXTRACTION + "/api/v1/projects/logs",
					{ params },
					options
				)
				.then((response) => {
					resolve(response);
				})
				.catch((e) => {
					console.log("error: ", e);
					reject(e);
				});
		});
	},
	getProjectsPagingInfo(itemsPerPageSelected, search = "", status = "") {
		return new Promise(function(resolve, reject) {
			let params = {
				itemsPerPage: itemsPerPageSelected,
				search: search,
				status: status,
			};
			axiosplugin
				.get(
					config.VUE_APP_EXTRACTION + "/api/v1/projects/pagingInfo",
					{ params },
					options
				)
				.then((response) => {
					resolve(response);
				})
				.catch((e) => {
					console.log("error: ", e);
					reject(e);
				});
		});
	},
	getActivitiesPagingInfo(itemsPerPageSelected, search = "", status = "") {
		let params = {
			itemsPerPage: itemsPerPageSelected,
			search: search,
			status: status,
		};
		return new Promise(function(resolve, reject) {
			axiosplugin
				.get(
					config.VUE_APP_EXTRACTION + "/api/v1/projects/logs/pagingInfo",
					{ params },
					options
				)
				.then((response) => {
					resolve(response);
				})
				.catch((e) => {
					console.log("error: ", e);
					reject(e);
				});
		});
	},
	getUserActivitiesPagingInfo(itemsPerPage, search = "", status = "") {
		let username = store.getters.getUsername;
		var params = {
			itemsPerPage: itemsPerPage,
			search: search,
			status: status,
		};
		return new Promise(function(resolve, reject) {
			axiosplugin
				.get(
					config.VUE_APP_EXTRACTION +
						"/api/v1/users/" +
						username +
						"/logs/pagingInfo",
					{ params },
					options
				)
				.then((response) => {
					resolve(response);
				})
				.catch((e) => {
					console.log("error: ", e);
					reject(e);
				});
		});
	},
	about() {
		return new Promise(function(resolve, reject) {
			axiosplugin
				.get(config.VUE_APP_EXTRACTION + "/api/v1/about/", options)
				.then((response) => {
					resolve(response);
				})
				.catch((e) => {
					console.log("error: ", e);
					reject(e);
				});
		});
	},
	//admin user
	getUsers() {
		return new Promise(function(resolve, reject) {
			axiosplugin
				.get(config.VUE_APP_EXTRACTION + "/api/v1/users/", options)
				.then((response) => {
					resolve(response);
				})
				.catch((e) => {
					console.log("error: ", e);
					reject(e);
				});
		});
	},
	postUser(user) {
		return new Promise(function(resolve, reject) {
			axiosplugin
				.post(config.VUE_APP_EXTRACTION + "/api/v1/users/add", user, options)
				.then((response) => {
					resolve(response);
				})
				.catch((e) => {
					console.log("error: ", e);
					reject(e);
				});
		});
	},
	updateUser(user) {
		return new Promise(function(resolve, reject) {
			axiosplugin
				.put(config.VUE_APP_EXTRACTION + "/api/v1/users/update", user, options)
				.then((response) => {
					resolve(response);
				})
				.catch((e) => {
					console.log("error: ", e);
					reject(e);
				});
		});
	},
	deleteUser(user) {
		return new Promise(function(resolve, reject) {
			axiosplugin
				.delete(
					config.VUE_APP_EXTRACTION +
						"/api/v1/users/" +
						user.username +
						"/remove",
					options
				)
				.then((response) => {
					resolve(response);
				})
				.catch((e) => {
					console.log("error: ", e);
					reject(e);
				});
		});
	},
	resetPassword(user) {
		return new Promise(function(resolve, reject) {
			axiosplugin
				.patch(
					config.VUE_APP_EXTRACTION +
						"/api/v1/users/" +
						user.UserId +
						"/password/reset",
					user,
					options
				)
				.then((response) => {
					resolve(response);
				})
				.catch((e) => {
					console.log("error: ", e);
					reject(e);
				});
		});
	},
	resetQrCode(username) {
		return new Promise(function(resolve, reject) {
			axiosplugin
				.patch(
					config.VUE_APP_EXTRACTION +
						"/api/v1/users/" +
						username +
						"/qrcode/reset",
					null,
					options
				)
				.then((response) => {
					resolve(response);
				})
				.catch((e) => {
					console.log("error: ", e);
					reject(e);
				});
		});
	},

	//files
	async downloadFile(projectId, id) {
		return new Promise(function(resolve, reject) {
			axiosplugin
				.post(
					config.VUE_APP_EXTRACTION + "/api/v1/extractionsweb",
					{ ProjectId: projectId, FileId: id.toString() },
					{
						responseType: "blob", // important
						onDownloadProgress: (event) => {
							console.log("progress", event);
						},
					}
				)
				.then((response) => {
					resolve(response);
				})
				.catch((e) => {
					reject(e);
				});
		});
	},

	async downloadSummary(projectId) {
		return new Promise(function(resolve, reject) {
			axiosplugin
				.get(
					config.VUE_APP_EXTRACTION +
						"/api/v1/projects/" +
						projectId +
						"/summary",

					{
						responseType: "blob", // important
						onDownloadProgress: (event) => {
							console.log("progress", event);
						},
					}
				)
				.then((response) => {
					resolve(response);
				})
				.catch((e) => {
					reject(e);
				});
		});
	},
	sendAuditResults(project, result, reason) {
		return new Promise(function(resolve, reject) {
			axiosplugin
				.patch(
					config.VUE_APP_EXTRACTION +
						"/api/v1/projects/" +
						project.id +
						"/audit",
					{ AuditSucceeded: result, Reason: reason },
					options
				)
				.then((response) => {
					resolve(response);
				})
				.catch((e) => {
					reject(e);
				});
		});
	},
	resendMail(username) {
		return new Promise(function(resolve, reject) {
			axiosplugin
				.get(
					config.VUE_APP_EXTRACTION +
						"/api/v1/users/" +
						username +
						"/mail/forward",
					options
				)
				.then((response) => {
					resolve(response);
				})
				.catch((e) => {
					console.log("error: ", e);
					reject(e);
				});
		});
	},
	sendLegalAuditResults(project, result, reason) {
		return new Promise(function(resolve, reject) {
			axiosplugin
				.patch(
					config.VUE_APP_EXTRACTION +
						"/api/v1/projects/" +
						project.id +
						"/audit/legal",
					{ AuditSucceeded: result, Reason: reason },
					options
				)
				.then((response) => {
					resolve(response);
				})
				.catch((e) => {
					reject(e);
				});
		});
	},
	getOrganisms(page = 1, itemsPerPage = 1, sortBy, sortOrder, search) {
		var params = {
			page: page,
			itemsPerPage: itemsPerPage,
			search: search,
			sortBy: sortBy === "name" ? "name" : sortBy,
			desc: sortOrder,
		};
		return new Promise(function(resolve, reject) {
			axiosplugin
				.get(
					config.VUE_APP_EXTRACTION + "/api/v1/organisms",
					{ params },
					options
				)
				.then((response) => {
					resolve(response);
				})
				.catch((e) => {
					console.log("error: ", e);
					reject(e);
				});
		});
	},
	getAllOrganisms() {
		return new Promise(function(resolve, reject) {
			axiosplugin
				.get(config.VUE_APP_EXTRACTION + "/api/v1/organisms/getAll", options)
				.then((response) => {
					resolve(response);
				})
				.catch((e) => {
					console.log("error: ", e);
					reject(e);
				});
		});
	},
	postOrganism(organism) {
		return new Promise(function(resolve, reject) {
			if (organism.emailAddress === "") organism.emailAddress = null;
			axiosplugin
				.post(
					config.VUE_APP_EXTRACTION + "/api/v1/organisms",
					organism,
					options
				)
				.then((response) => {
					resolve(response);
				})
				.catch((e) => {
					console.log("error: ", e);
					reject(e);
				});
		});
	},
	getOrganismsPagingInfo(itemsPerPageSelected, search = "") {
		return new Promise(function(resolve, reject) {
			let params = {
				itemsPerPage: itemsPerPageSelected,
				search: search,
			};
			axiosplugin
				.get(
					config.VUE_APP_EXTRACTION + "/api/v1/organisms/pagingInfo",
					{ params },
					options
				)
				.then((response) => {
					resolve(response);
				})
				.catch((e) => {
					console.log("error: ", e);
					reject(e);
				});
		});
	},
	deleteOrganism(organism) {
		return new Promise(function(resolve, reject) {
			axiosplugin
				.delete(
					config.VUE_APP_EXTRACTION + "/api/v1/organisms/" + organism.id,
					options
				)
				.then((response) => {
					resolve(response);
				})
				.catch((e) => {
					console.log("error: ", e);
					reject(e);
				});
		});
	},
	updateOrganism(organism) {
		if (organism.emailAddress === "") organism.emailAddress = null;
		return new Promise(function(resolve, reject) {
			axiosplugin
				.patch(
					config.VUE_APP_EXTRACTION + "/api/v1/organisms/" + organism.id,
					organism,
					options
				)
				.then((response) => {
					resolve(response);
				})
				.catch((e) => {
					console.log("error: ", e);
					reject(e);
				});
		});
	},
	getStatus(endpoint) {
		return new Promise(function(resolve, reject) {
			axiosplugin
				.get(
					config.VUE_APP_EXTRACTION + "/api/v1/Projects/" + endpoint,
					options
				)
				.then((response) => {
					resolve(response);
				})
				.catch((e) => {
					console.log("error: ", e);
					reject(e);
				});
		});
	},
	getStatisticsProjects(
		page = 1,
		itemsPerPage = 1,
		search = "",
		sortBy,
		sortOrder,
		startDate,
		range = "month"
	) {
		var params = {
			page: page,
			itemsPerPage: itemsPerPage,
			search: search,
			sortBy: sortBy,
			sortOrder: sortOrder,

			startDate: startDate,
			range: range,
		};
		return new Promise(function(resolve, reject) {
			axiosplugin
				.get(
					config.VUE_APP_EXTRACTION + "/api/v1/Statistics",
					{ params },
					options
				)
				.then((response) => {
					resolve(response);
				})
				.catch((e) => {
					console.log("error: ", e);
					reject(e);
				});
		});
	},
	getStatisticsGraph(search, startDate, range = "month") {
		var params = {
			search: search,
			startDate: startDate,
			range: range,
		};
		return new Promise(function(resolve, reject) {
			axiosplugin
				.get(
					config.VUE_APP_EXTRACTION + "/api/v1/Statistics/getgraphinfo",
					{ params },
					options
				)
				.then((response) => {
					resolve(response);
				})
				.catch((e) => {
					console.log("error: ", e);
					reject(e);
				});
		});
	},

	getStatisticsSystem(
		page = 1,
		itemsPerPage = 1,
		search = "",
		sortBy,
		sortOrder,
		startDate,
		range = "month"
	) {
		var params = {
			page: page,
			itemsPerPage: itemsPerPage,
			search: search,
			sortBy: sortBy,
			sortOrder: sortOrder,
			startDate: startDate,
			range: range,
		};
		return new Promise(function(resolve, reject) {
			axiosplugin
				.get(
					config.VUE_APP_EXTRACTION + "/api/v1/Statistics/system",
					{ params },
					options
				)
				.then((response) => {
					resolve(response);
				})
				.catch((e) => {
					console.log("error: ", e);
					reject(e);
				});
		});
	},
	getTypeCrimeList() {
		return new Promise(function(resolve, reject) {
			axiosplugin
				.get(
					config.VUE_APP_EXTRACTION + "/api/v1/Statistics/getcrimetypelist",
					options
				)
				.then((response) => {
					resolve(response);
				})
				.catch((e) => {
					console.log("error: ", e);
					reject(e);
				});
		});
	},
	getTypeCrimeTotal(search, crimeName, startDate, range = "month") {
		var params = {
			search: search,
			crime: crimeName,
			startDate: startDate,
			range: range,
		};
		return new Promise(function(resolve, reject) {
			axiosplugin
				.get(
					config.VUE_APP_EXTRACTION + "/api/v1/Statistics/getcrimetype",
					{ params },
					options
				)
				.then((response) => {
					resolve(response);
				})
				.catch((e) => {
					console.log("error: ", e);
					reject(e);
				});
		});
	},
	getOrganismTotal(search, organismName, startDate, range = "month") {
		var params = {
			search: search,
			organism: organismName,
			startDate: startDate,
			range: range,
		};
		return new Promise(function(resolve, reject) {
			axiosplugin
				.get(
					config.VUE_APP_EXTRACTION + "/api/v1/Statistics/getorganisms",
					{ params },
					options
				)
				.then((response) => {
					resolve(response);
				})
				.catch((e) => {
					console.log("error: ", e);
					reject(e);
				});
		});
	},
	getCameraTotal(search, startDate, range = "month") {
		var params = {
			search: search,
			startDate: startDate,
			range: range,
		};
		return new Promise(function(resolve, reject) {
			axiosplugin
				.get(
					config.VUE_APP_EXTRACTION + "/api/v1/Statistics/getCameraTotal",
					{ params },
					options
				)
				.then((response) => {
					resolve(response);
				})
				.catch((e) => {
					console.log("error: ", e);
					reject(e);
				});
		});
	},
	getStatisticsCameras(
		page = 1,
		itemsPerPage = 1,
		search = "",
		sortBy,
		sortOrder,
		startDate,
		range = "month"
	) {
		var params = {
			page: page,
			itemsPerPage: itemsPerPage,
			search: search,
			sortBy: sortBy,
			sortOrder: sortOrder,
			startDate: startDate,
			range: range,
		};
		return new Promise(function(resolve, reject) {
			axiosplugin
				.get(
					config.VUE_APP_EXTRACTION + "/api/v1/Statistics/cameras",
					{ params },
					options
				)
				.then((response) => {
					resolve(response);
				})
				.catch((e) => {
					console.log("error: ", e);
					reject(e);
				});
		});
	},

	getStatisticsStatusGraph(search, startDate, range = "month") {
		var params = {
			search: search,
			startDate: startDate,
			range: range,
		};
		return new Promise(function(resolve, reject) {
			axiosplugin
				.get(
					config.VUE_APP_EXTRACTION + "/api/v1/Statistics/getgraphstatusinfo",
					{ params },
					options
				)
				.then((response) => {
					resolve(response);
				})
				.catch((e) => {
					console.log("error: ", e);
					reject(e);
				});
		});
	},
	getSystemPagingInfo(itemsPerPage = 10, search = "", startDate, range) {
		return new Promise(function(resolve, reject) {
			let params = {
				itemsPerPage: itemsPerPage,
				search: search,
				startDate: startDate,
				range: range,
			};
			axiosplugin
				.get(
					config.VUE_APP_EXTRACTION + "/api/v1/Statistics/pagingInfoSystem",
					{ params },
					options
				)
				.then((response) => {
					resolve(response);
				})
				.catch((e) => {
					console.log("error: ", e);
					reject(e);
				});
		});
	},
	getProjectsStatisticsPagingInfo(
		itemsPerPageSelected,
		search = "",
		startDate,
		range
	) {
		return new Promise(function(resolve, reject) {
			let params = {
				itemsPerPage: itemsPerPageSelected,
				search: search,
				startDate: startDate,
				range: range,
			};
			axiosplugin
				.get(
					config.VUE_APP_EXTRACTION + "/api/v1/Statistics/pagingInfo",
					{ params },
					options
				)
				.then((response) => {
					resolve(response);
				})
				.catch((e) => {
					console.log("error: ", e);
					reject(e);
				});
		});
	},
	getUsersTotal(search, username = "", startDate, range = "day") {
		var params = {
			search: search,
			userName: username,
			startDate: startDate,
			range: range,
		};
		return new Promise(function(resolve, reject) {
			axiosplugin
				.get(
					config.VUE_APP_EXTRACTION + "/api/v1/Statistics/getusertotal",
					{ params },
					options
				)
				.then((response) => {
					resolve(response);
				})
				.catch((e) => {
					console.log("error: ", e);
					reject(e);
				});
		});
	},
	getCamerasPagingInfo(itemsPerPageSelected, search = "", startDate, range) {
		return new Promise(function(resolve, reject) {
			let params = {
				itemsPerPage: itemsPerPageSelected,
				search: search,
				startDate: startDate,
				range: range,
			};
			axiosplugin
				.get(
					config.VUE_APP_EXTRACTION + "/api/v1/Statistics/pagingInfoCameras",
					{ params },
					options
				)
				.then((response) => {
					resolve(response);
				})
				.catch((e) => {
					console.log("error: ", e);
					reject(e);
				});
		});
	},
	getHeatMap(search = "", startDate, range) {
		return new Promise(function(resolve, reject) {
			let params = {
				search: search,
				startDate: startDate,
				range: range,
			};
			axiosplugin
				.get(
					config.VUE_APP_EXTRACTION + "/api/v1/Statistics/heatMapData",
					{ params },
					options
				)
				.then((response) => {
					resolve(response);
				})
				.catch((e) => {
					console.log("error: ", e);
					reject(e);
				});
		});
	},
	updateProjectSecondaryOrganism(projectId, secondaryOrgs) {
		console.log(projectId);
		console.log(secondaryOrgs);
		return new Promise(function(resolve, reject) {
			axiosplugin
				.put(
					config.VUE_APP_EXTRACTION +
						"/api/v1/projects/" +
						projectId +
						"/secondaryOrganisms",
					secondaryOrgs,
					options
				)
				.then((response) => {
					resolve(response);
				})
				.catch((e) => {
					console.log("error: ", e);
					reject(e);
				});
		});
	},
};
